module.exports = __webpack_public_path__ + "static/media/loadingwall.4a35f914.gif";